import React, { useCallback, useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useMessages } from "../MessagesContext";
import { CreateMessage } from "./CreateMessage";
import { MessagesList } from "./MessagesList";

const useStyles = makeStyles(() => ({
  root: {
    width: 732,
    minWidth: 440,
    height: 659,
    padding: "16px 0 24px 24px",
    borderRadius: 16,
    backgroundColor: "#ffffff",
    boxShadow: "0 0 8px #C2C9D682",
    display: "flex",
    flexDirection: "column",
    rowGap: "24px",
    justifyContent: "end",
  },
  noMessages: {
    fontSize: 14,
    color: "#989BA8",
    textAlign: "center",
    paddingBottom: 300,
  },
}));

export const Messages = () => {
  const messagesContainerRef = useRef<HTMLDivElement>(null);
  const { selectedConversation, sendMessage, makeSeen } = useMessages();
  const classes = useStyles();
  const [previousConversationId, setPreviousConversationId] =
    useState<string>("");

  useEffect(() => {
    if (selectedConversation?.id) {
      setPreviousConversationId(selectedConversation.id);
    }
  }, [selectedConversation?.id]);

  const messages = selectedConversation?.messages || [];
  const temp = selectedConversation?.temp || { text: "", attachments: [] };

  const handleSendMessage = useCallback(async () => {
    await sendMessage!();
  }, [sendMessage]);

  return (
    <div className={classes.root}>
      {selectedConversation?.id === previousConversationId ? (
        <>
          <MessagesList
            messages={messages}
            messagesContainerRef={messagesContainerRef}
            makeSeen={makeSeen!}
          />

          <CreateMessage temp={temp} onSendMessage={handleSendMessage} />
        </>
      ) : (
        <div className={classes.noMessages}>No messages found.</div>
      )}
    </div>
  );
};
